export default __webpack_public_path__ + "static/media/icon_menu_support.18873b41.svg";